import Cookies from 'universal-cookie';
import { persistor } from './store';
const cookies = new Cookies();
const initialState = {
  isAuthenticated: !!cookies.get('AccessToken') || !!sessionStorage.getItem('AccessToken'),
  token: cookies.get('AccessToken') || sessionStorage.getItem('AccessToken'),
};
const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      cookies.set('AccessToken', action.payload, { path: '/' });
      sessionStorage.setItem('AccessToken', action.payload);
      localStorage.setItem('AccessToken', action.payload);
      return { ...state, isAuthenticated: true, token: action.payload };
    
      case 'LOGOUT':
        cookies.remove('AccessToken', { path: '/' });
        sessionStorage.removeItem('AccessToken');
        localStorage.removeItem('AccessToken');
        localStorage.removeItem('email');
        sessionStorage.removeItem("loginDeployVersion");
       sessionStorage.removeItem("acknowledgedDeploy");
       localStorage.removeItem("lastSeenDeploy");
       sessionStorage.removeItem("ssoLoginCompleted");
        localStorage.removeItem('isPartiallyVerified');
        localStorage.removeItem('isFullyVerified');
        localStorage.removeItem('BenefitTabVisibility');
        sessionStorage.removeItem('ssoRedirectInProgress');
        sessionStorage.removeItem('ssoBrand');
        return { ...state, isAuthenticated: false, token: null };

        case 'SESSION_EXPIRED':
            cookies.remove('AccessToken', { path: '/session-expired' });
            sessionStorage.removeItem('AccessToken');
            localStorage.removeItem('AccessToken');
            localStorage.removeItem('email');
            localStorage.removeItem('BenefitTabVisibility');
            sessionStorage.removeItem("loginDeployVersion");
            sessionStorage.removeItem("acknowledgedDeploy");
            localStorage.removeItem("lastSeenDeploy");
            sessionStorage.removeItem("ssoLoginCompleted");
             localStorage.removeItem('isPartiallyVerified');
        localStorage.removeItem('isFullyVerified');
        sessionStorage.removeItem('ssoRedirectInProgress');
        sessionStorage.removeItem('ssoBrand');
            return { ...state, isAuthenticated: false, token: null };
    
    default:
      return state;
  }
};

export default authReducer;
